import React from 'react';

export const LoadingSlotCard = () => {
  return (
    <div className={`roomCard slot`}>
      <div className="main shine" />
    </div>
  );
};
